<script setup>
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { EventManager, Actions, ChangeSectionPayload } from "@events";
import { SectionList } from "@module-system";
import { useVideoCallState } from "@/stores/videoCallState";

import { ref } from "vue";
import { onMounted } from "vue";

let actionEmitter = null;
let loading = ref(true);


const props = defineProps({
    rtcId: {
        type: String,
        required: true,
    }
});

function openChat() {
    actionEmitter.emit(
        Actions.ChangeSectionModule,
        new ChangeSectionPayload({
            section: SectionList.CallRightPanel,
            key: "chat-panel"
        })
    );
    actionEmitter.emit(Actions.OpenChatPanel);
}

onMounted(() => {
    actionEmitter = EventManager.getActionEmitter(props.rtcId);
    const state = useVideoCallState(props.rtcId);

    state.webrtcConnectedPromise.then(() => {
        loading.value = false;
    });
});

</script>
<template>
    <VideoCallButton icon="mdi-chat" @click="openChat" :disabled="loading" />
</template>
  